import {
  deliveryListSchema,
  deliverySchema,
  type Delivery,
  type DeliveryList,
  type ServiceRequest,
} from '@secretario/shared';
import { apiFetch } from './http.js';

export const DELIVERIES_KEY = ['deliveries'] as const;

export async function listDeliveries(): Promise<DeliveryList> {
  return deliveryListSchema.parse(await apiFetch<unknown>('/v1/deliveries'));
}

export async function getDelivery(id: string): Promise<Delivery> {
  return deliverySchema.parse(await apiFetch<unknown>(`/v1/deliveries/${encodeURIComponent(id)}`));
}

export async function requestService(input: ServiceRequest): Promise<Delivery> {
  return deliverySchema.parse(
    await apiFetch<unknown>('/v1/deliveries', { method: 'POST', body: input }),
  );
}

export async function applyDeliveryAction(id: string, action: string): Promise<Delivery> {
  return deliverySchema.parse(
    await apiFetch<unknown>(`/v1/deliveries/${encodeURIComponent(id)}/apply`, {
      method: 'POST',
      body: { action },
    }),
  );
}

export function deleteDelivery(id: string): Promise<void> {
  return apiFetch<void>(`/v1/deliveries/${encodeURIComponent(id)}`, { method: 'DELETE' });
}
